module.exports = __webpack_public_path__ + "assets/inverted-logo.4213a004c930906c9b801e4db41c127d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/inverted-logo.png
 ** module id = 97
 ** module chunks = 0
 **/